import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/home/HomePage.vue')
  },

  // {
  //   path: '/solutions',
  //   name: 'solution',
  //   children: [
  //       {
  //         path: 'individuals',
  //         name: 'individuals',
  //         component: () => import('@/pages/solutions/ForSmallBusiness.vue')
  //       },
  //       {
  //         path: 'enterprise',
  //           name: 'enterprise',
  //           component: () => import('@/pages/solutions/ForPartners.vue')
  //       }
  //       ],
  //   // component: () => import('@/pages/home/HomePage.vue')
  // },
  {
    path: '/pricing',
    name: 'pricing',
    redirect: '/#price',
    component: () => import('@/pages/pricing/PricingPage.vue')
  },
  {
    path: '/about',
    name: 'about',
    redirect: '/#about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/pages/about/AboutPage.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    redirect: '/#contact',
    component: () => import('@/pages/contact/ContactPage.vue')
  },
  // {
  //   path: '/outro',
  //   name: 'outro',
  //   component: () => import('@/pages/outro/OutroPage.vue')
  // },
  // {
  //   path: '/enterprise/adherence',
  //   name: 'adherence',
  //   component: () => import('@/pages/solutions/Adherence.vue')
  // },
  {
    path: '/document',
    name: 'document',
    children: [
      {
        path: 'terms-conditions',
        name: 'terms-conditions',
        component: () => import('@/pages/documents/TermsConditions.vue')
      }
    ],
    // component: () => import('@/pages/home/HomePage.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/error/NotFoundPage.vue')
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Add this code after your router creation but before the export statement
router.beforeEach((to, from, next) => {
  // Block specific routes
  if (to.name === 'about' || to.name === 'adherence' || to.name === 'individuals') {
    // Change this condition to your actual requirement (authentication check, etc.)
    const isAllowed = false; // Set your condition here

    if (isAllowed) {
      next(); // Allow access
    } else {
      next('/'); // Redirect to home page if not allowed
    }
  } else {
    next(); // Allow navigation for all other routes
  }
})

export default router
